<template>
  <div class="address-container">
    <p>Müraciətin xəritədə ünvanı</p>
    <ul class="address-list">
      <li v-for="(address, index) in addresses" :key="index" class="hover">
        {{ address.formatted_address }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "GoogleAddressList",
  props: {
    addresses: Array,
  },
};
</script>
<style lang="scss" scoped>
.address-container {
  margin: 10px 5px;
  border-radius: 10px;
  box-shadow: 2px 2px 5px 5px lightgray;

  & > p {
    background-color: rgb(38, 192, 138);
    padding: 8px;
    font-size: 24px;
    color: white;
    border-radius: 5px 5px 0 0;
    margin-bottom: 3px;
  }
}
.address-list {
  padding: 0px;
  & li {
    list-style: none;
    padding: 6px;

    &.hover:hover {
      background-color: lightgray;
    }

    &.selected {
      background-color: #9b9b9b;
      color: white;
    }
  }
}
</style>
